module.exports = __webpack_public_path__ + "static/img/Icon1.9b116b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon1.png
// module id = nnxP
// module chunks = 1